import { render, staticRenderFns } from "./testPaperEdit.vue?vue&type=template&id=e2bb5ce8&scoped=true"
import script from "./testPaperEdit.vue?vue&type=script&lang=js"
export * from "./testPaperEdit.vue?vue&type=script&lang=js"
import style0 from "./testPaperEdit.vue?vue&type=style&index=0&id=e2bb5ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bb5ce8",
  null
  
)

export default component.exports